export default __webpack_public_path__ + "a8d2b092cee329fbf9803eb65309be8e.gif";